import apiClient from './apiClient';

export const contentieuxAPI = {
  cases: {
    list: (params) => apiClient.get('/contentieux/cases/', { params }),
    get: (id) => apiClient.get(`/contentieux/cases/${id}/`),
    create: (data) => apiClient.post('/contentieux/cases/', data),
    update: (id, data) => apiClient.put(`/contentieux/cases/${id}/`, data),
    delete: (id) => apiClient.delete(`/contentieux/cases/${id}/`),
  },
  precontentieux: {
    list: (params) => apiClient.get('/contentieux/precontentieux/', { params }),
    get: (id) => apiClient.get(`/contentieux/precontentieux/${id}/`),
    create: (data) => apiClient.post('/contentieux/precontentieux/', data),
    update: (id, data) => apiClient.put(`/contentieux/precontentieux/${id}/`, data),
    delete: (id) => apiClient.delete(`/contentieux/precontentieux/${id}/`),
  },
  procedures: {
    list: (params) => apiClient.get('/contentieux/procedures/', { params }),
    get: (id) => apiClient.get(`/contentieux/procedures/${id}/`),
    create: (data) => apiClient.post('/contentieux/procedures/', data),
    update: (id, data) => apiClient.put(`/contentieux/procedures/${id}/`, data),
    delete: (id) => apiClient.delete(`/contentieux/procedures/${id}/`),
  },
  hearings: {
    list: (params) => apiClient.get('/contentieux/hearings/', { params }),
    get: (id) => apiClient.get(`/contentieux/hearings/${id}/`),
    create: (data) => apiClient.post('/contentieux/hearings/', data),
    update: (id, data) => apiClient.put(`/contentieux/hearings/${id}/`, data),
    delete: (id) => apiClient.delete(`/contentieux/hearings/${id}/`),
  },
  judgments: {
    list: (params) => apiClient.get('/contentieux/judgments/', { params }),
    get: (id) => apiClient.get(`/contentieux/judgments/${id}/`),
    create: (data) => apiClient.post('/contentieux/judgments/', data),
    update: (id, data) => apiClient.put(`/contentieux/judgments/${id}/`, data),
    delete: (id) => apiClient.delete(`/contentieux/judgments/${id}/`),
  },
  infractions: {
    list: (params) => apiClient.get('/contentieux/infractions/', { params }),
    get: (id) => apiClient.get(`/contentieux/infractions/${id}/`),
    create: (data) => apiClient.post('/contentieux/infractions/', data),
    update: (id, data) => apiClient.put(`/contentieux/infractions/${id}/`, data),
    delete: (id) => apiClient.delete(`/contentieux/infractions/${id}/`),
  },
  saisies: {
    list: (params) => apiClient.get('/contentieux/saisies/', { params }),
    get: (id) => apiClient.get(`/contentieux/saisies/${id}/`),
    create: (data) => apiClient.post('/contentieux/saisies/', data),
    update: (id, data) => apiClient.put(`/contentieux/saisies/${id}/`, data),
    delete: (id) => apiClient.delete(`/contentieux/saisies/${id}/`),
  },
  recouvrements: {
    list: (params) => apiClient.get('/contentieux/recouvrements/', { params }),
    get: (id) => apiClient.get(`/contentieux/recouvrements/${id}/`),
    create: (data) => apiClient.post('/contentieux/recouvrements/', data),
    update: (id, data) => apiClient.put(`/contentieux/recouvrements/${id}/`, data),
    delete: (id) => apiClient.delete(`/contentieux/recouvrements/${id}/`),
  },
  recouvrementPayments: {
    list: (params) => apiClient.get('/contentieux/recouvrement-payments/', { params }),
    get: (id) => apiClient.get(`/contentieux/recouvrement-payments/${id}/`),
    create: (data) => apiClient.post('/contentieux/recouvrement-payments/', data),
    update: (id, data) => apiClient.put(`/contentieux/recouvrement-payments/${id}/`, data),
    delete: (id) => apiClient.delete(`/contentieux/recouvrement-payments/${id}/`),
  },
};
